import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import type { TPersonalizationProvider, IDeps } from './models';
import { PersonalizationProvider as Component } from './personalization-provider';

export const PersonalizationProvider = createWidgetWithErrorBoundary<
    IDeps,
    TPersonalizationProvider
>({})(Component);
